module.exports = __webpack_public_path__ + "static/media/Slideshow Karaoke (MLH).c9545493.png";